import React from 'react'
import { Helmet } from "react-helmet";
import JapaADSE from '../../components/Courses/JapaADSE/JapaADSE';


const JapaADSEPage = () => {

  return (
    <>
      <Helmet>
  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Basic Meta */}
  <title>Advanced Diploma in Software Engineering (ADSE) | Aptech Lekki Centre</title>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  
  <meta
    name="description"
    content="Enroll in Aptech Lekki's Advanced Diploma in Software Engineering (ADSE) program and kickstart your international tech career. Learn full-stack web development, mobile app development, cloud computing, and more. Start your tech migration journey from Lekki, Lagos today!"
  />

  <meta
    name="keywords"
    content="Aptech Lekki ADSE, Advanced Diploma Software Engineering Nigeria, Coding programs Lagos, Learn programming Lekki, Japa tech route, Study abroad with coding, Full-stack developer training Nigeria, Mobile App Development Lekki, Web Development Lagos, Tech career abroad"
  />

  <meta name="author" content="Aptech Lekki Centre" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://aptechlekki.com/courses/japa-adse" />

  {/* Open Graph Meta for social media */}
  <meta property="og:title" content="Advanced Diploma in Software Engineering (ADSE) | Aptech Lekki Centre" />
  <meta property="og:description" content="Build a global tech career with Aptech Lekki's Advanced Software Engineering Program. Become a certified full-stack developer and open migration opportunities." />
  <meta property="og:url" content="https://aptechlekki.com/courses/japa-adse" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Advanced Diploma in Software Engineering (ADSE) | Aptech Lekki" />
  <meta name="twitter:description" content="Learn Software Engineering and prepare for international tech opportunities with Aptech Lekki's ADSE Program." />
  <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
</Helmet>

    <JapaADSE />
    </>
  )
}

export default JapaADSEPage